import { IconInfo, TooltipTip } from '@components/icons';
import { Wrapper, InfoWrapper, TipWrapper, Content } from './Tooltip.styles';
import { useState } from 'react';
import mixpanel from 'mixpanel-browser';

export interface TooltipProps {
  name?: string;
  position?: 'left' | 'center' | 'right';
  children: React.ReactNode;
}

export default function Tooltip({ name, position, children }: TooltipProps) {
  const [isShown, setIsShown] = useState(false);
  return (
    <Wrapper
      position={`${position}`}
      isShown={`${isShown}`}
      onMouseEnter={() => {
        setIsShown(true);
        if (!name) return;
        mixpanel.track('TooltipShown', { name });
      }}
      onMouseLeave={() => setIsShown(false)}
    >
      <InfoWrapper>
        <IconInfo />
      </InfoWrapper>
      {isShown && (
        <Content>
          <TipWrapper>
            <TooltipTip />
          </TipWrapper>
          {children}
        </Content>
      )}
    </Wrapper>
  );
}
